import { DatePipe } from '@angular/common';
import { writeLog, writeError } from './logs';

export function isDateAfter(date1: Date, date2?: Date): boolean {
  // defaults to now if no second date is provided
  date2 = !date2 ? new Date() : date2;
  return date1.getTime() > date2.getTime();
}

export function formatDate(date: Date, format: string): string {
  const s = new DatePipe('en-US');
  return s.transform(date, format);
}

export class DateTime {

  constructor(
    public day = 0,
    public month = 0,
    public year = 0,
    public hour = 0,
    public minute = 0,
    public seconds = 0,
  ) { }

  static fromDateTime(obj: any): DateTime {
    writeLog(obj);
    return new DateTime(
      obj.day != null ? obj.day : 0,
      obj.month != null ? obj.month : 0,
      obj.year != null ? obj.year : 0,
      obj.hour != null ? obj.hour : 0,
      obj.minute != null ? obj.minute : 0,
      obj.second != null ? obj.second : 0);
  }

  toDate(): Date {
    return new Date(`${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}:${this.seconds}`);
  }

  format(format: string): string {
    const s = new DatePipe('en-US');
    return s.transform(this.toDate(), format);
  }

  setTime(date?: Date) {
    this.hour = date.getHours();
    this.minute = date.getMinutes();
    this.seconds = date.getSeconds();
  }

  setDate(date?: Date) {
    this.day = date.getDate();
    this.month = date.getMonth() + 1;
    this.year = date.getFullYear();
    writeLog('date data', this);
  }

  setDateTime(date?: Date|string) {
    const realDate: Date = (date instanceof String) ? new Date(date) : <Date> date;
    if(date && date != null) {
      this.day = realDate.getDate();
      this.month = realDate.getMonth() + 1;
      this.year = realDate.getFullYear();
      this.hour = realDate.getHours();
      this.minute = realDate.getMinutes();
      this.seconds = realDate.getSeconds();
    }
    writeLog('date data', this);
  }

  setTimeLocal(datetime?: DateTime) {
    this.hour = datetime.hour;
    this.minute = datetime.minute;
    this.seconds = datetime.seconds;
  }

  setDateLocal(datetime?: DateTime) {
    this.day = datetime.day;
    this.month = datetime.month;
    this.year = datetime.year;
  }

  isBefore(date2?: Date): boolean {
    // defaults to now if no second date is provided
    date2 = !date2 ? new Date() : date2;
    return this.toDate().getTime() < date2.getTime();
  }

  isAfter(date2?: Date): boolean {
    // defaults to now if no second date is provided
    date2 = !date2 ? new Date() : date2;
    return this.toDate().getTime() > date2.getTime();
  }
}

/*
  accepts a time in format `H:m a` and returns the DateTime model
*/
export function getTimeData(timeString: string): DateTime {
  const timeData = new DateTime();

  const half = timeString.split(':');
  timeData.hour = +half[0];

  const half2 = half[1].split(' ');
  timeData.minute = +half2[0];

  // check 24hr
  if (half2[1].toLowerCase() === 'pm') {
    timeData.hour = timeData.hour + 12;
  }

  return timeData;
}
